import { HotelDetailsViewModel, HotelRoomsAndRatesViewModel } from 'models';

export const adaptPropertyInfoDetails = (data): HotelDetailsViewModel => {
  const propertyInfoDetails = hasBffResponse(data) && data.data.propertyInfo.pwaOnlyBffResponse.details;

  return propertyInfoDetails ? JSON.parse(propertyInfoDetails) : data;
};

export const adaptPropertyInfoOffers = (data): HotelRoomsAndRatesViewModel => {
  const propertyInfoOffers = hasBffResponse(data) && data.data.propertyInfo.pwaOnlyBffResponse.offers;

  return propertyInfoOffers ? JSON.parse(propertyInfoOffers) : data;
};

function hasBffResponse(data: any) {
  return data.data && data.data.propertyInfo && data.data.propertyInfo.pwaOnlyBffResponse;
}
